import { render, staticRenderFns } from "./OptionBulkUpdater.vue?vue&type=template&id=49b4b016&scoped=true"
import script from "./OptionBulkUpdater.vue?vue&type=script&lang=ts"
export * from "./OptionBulkUpdater.vue?vue&type=script&lang=ts"
import style0 from "./OptionBulkUpdater.vue?vue&type=style&index=0&id=49b4b016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b4b016",
  null
  
)

export default component.exports